import React from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';
import { Label, FormContainer, Select, DatePicker, NumberInput, ValidationMessage } from './styles';
import DownArrow from '../../../../../../CommonComponents/svgs/DownArrow';
import { 
    ScheduleType as ScheduleTypeConstants, 
    ExchangeType as ExchangeTypeConstants, 
    Frequency as FrequencyConstants,
    DateFormat,
    ExchangesMaxLimit as ExchangesMaxLimitConstant,
    ExchangesMinLimit as ExchangesMinLimitConstant 
} from '../../constants';
import {
    InputField
} from '../../../../../../CommonComponents/commonStyles';

const { Option } = Select;

const ScheduleOptions = (props) => {
    const { handleExchangeTypeChange, exchangeType, scheduleType,
        frequency, startDate, numberOfExchanges, endDate, setFrequency, setStartDate, 
        setNumberOfExchanges, setEndDate, spawnRange, isSpawn, isNew, isSpawnApproved,
        setDirty, focusedOutExchangeType, focusedOutFrequency, focusedOutStartDate, focusedOutNumberOfExchanges, focusedOutSpawnDate,
        setFocusedOutExchangeType, setFocusedOutFrequency, setFocusedOutStartDate, setFocusedOutNumberOfExchanges,
        setFocusedOutSpawnDate
    } = props;
    const disabled = (scheduleType === ScheduleTypeConstants.recurring || isSpawn);
    const isRecurring = (scheduleType === ScheduleTypeConstants.recurring);
     
    return (
        <FormContainer>
            {isRecurring && <Row>
                <Col lg={{ span: 8 }} md={{ span: 10 }}>
                    <Label id="frequencyLabel">Frequency</Label>
                    <Select
                        role={false}
                        id="selFrequency"
                        aria-labelledby="frequencyLabel"
                        className="custom-input-select"
                        placeholder={'Select Frequency'}
                        suffixIcon={<DownArrow></DownArrow>}
                        onChange={(val) => {setFrequency(val); setDirty(true);}}
                        onBlur={() => setFocusedOutFrequency(true)}
                        value={frequency} // because we don't want to set empty value
                    >
                        <Option value={FrequencyConstants.quaterly}>Quarterly</Option>
                        <Option value={FrequencyConstants.monthly}>Monthly</Option>
                        <Option value={FrequencyConstants.weekly}>Weekly</Option>
                    </Select>
                    <ValidationMessage visible={focusedOutFrequency && !frequency}>Please select frequency</ValidationMessage>
                </Col>
                <Col lg={{ span: 8, offset: 2 }} md={{ span: 10, offset: 2 }}>
                    <Label id="startDateLabel">{!isNew ? isSpawnApproved ? "Next scheduled payment date" : "Start Date" : "Start Date"}</Label>
                    <DatePicker
                        id="startDate"
                        aria-labelledby="startDateLabel"
                        dropdownClassName='recommend-an-exchange-datepicker'
                        placement='bottomRight'
                        placeholder="Select Start Date"
                        disabledDate = {(current) => {
                            if(isNew || frequency === FrequencyConstants.weekly) {
                                return current < moment().startOf('day');
                            }
                            return current && current < moment().endOf('day');
                        }}
                        format={DateFormat}
                        value={startDate && moment(startDate, DateFormat)}
                        onChange={(val) => {setStartDate(val? val.format(DateFormat):null); setDirty(true);}}
                        onBlur={() => setFocusedOutStartDate(true)}
                    />
                    <ValidationMessage visible={focusedOutStartDate && !startDate}>Please enter start date</ValidationMessage>
                </Col>
            </Row>}
            {isRecurring && <Row>
                <Col lg={{ span: 8 }} md={{ span: 10 }}>
                    <Label id="numberOfExchangeLabel">Number of exchanges</Label>
                    <InputField
                        width={true}
                        aria-labelledby="numberOfExchangeLabel"
                        type='text'
                        placeholder='Enter number of exchanges'
                        value={numberOfExchanges || ''}
                       // disabled={!isNew}
                        onChange={(e) => { if (Number(e.target.value) <= ExchangesMaxLimitConstant) { setNumberOfExchanges(e.target.value); setDirty(true); } }}
                        onBlur={() => setFocusedOutNumberOfExchanges(true)}
                    />
                    <ValidationMessage visible={focusedOutNumberOfExchanges}>
                        {!numberOfExchanges && 'Please enter number of exchanges'}
                        {numberOfExchanges && (numberOfExchanges < 2) && 'Please enter at least two payments'}
                    </ValidationMessage>
                </Col>
                <Col lg={{ span: 8, offset: 2 }} md={{ span: 10, offset: 2 }}>
                    <Label id="endDateLabel">End Date</Label>
                    <DatePicker
                        id="endDate"
                        aria-labelledby="endDateLabel"
                        placeholder="End Date"
                        disabled={true}
                        disableIcon={true}
                        format={DateFormat}
                        value={endDate && moment(endDate, DateFormat)}
                        onChange={(val) => { setEndDate(val.format(DateFormat)); setDirty(true); }}
                    />
                </Col>
            </Row>}
            <Row>
                <Col lg={{ span: 8 }} md={{ span: 10 }}>
                    <Label id="exchangeTypeLabel">Exchange Type</Label>
                    <Select
                        role={false}
                        id="selExchangeType"
                        aria-labelledby="exchangeTypeLabel"
                        className="custom-input-select"
                        placeholder={'Select exchange type'}
                        suffixIcon={<DownArrow></DownArrow>}
                        onChange={handleExchangeTypeChange}
                        onBlur={() => setFocusedOutExchangeType(true)}
                        value={exchangeType} // because we don't want to set empty value
                        disabled={disabled || isSpawn || !isNew}
                    >
                        <Option value={ExchangeTypeConstants.custom}>Custom Exchange</Option>
                        <Option value={ExchangeTypeConstants.reallocation}>Reallocation</Option>
                    </Select>
                    <ValidationMessage visible={focusedOutExchangeType && !exchangeType}>Please select exchange type</ValidationMessage>
                </Col>
            </Row>
            {isSpawn && spawnRange && <Row>
                <Col lg={{ span: 8 }} md={{ span: 10 }}>
                    <Label id="spawnDateLabel">Spawn Date</Label>
                    <DatePicker
                        id="spawnDate"
                        aria-labelledby="spawnDateLabel"
                        dropdownClassName='recommend-an-exchange-datepicker'
                        placement='bottomRight'
                        placeholder="Select Execution Date"
                        disabled={false}
                        format={DateFormat}
                        value={startDate && moment(startDate, DateFormat)}
                        onChange={(val) => {setStartDate(val? val.format(DateFormat): null); setDirty(true); }}
                        onBlur={() => setFocusedOutSpawnDate(true)}
                        disabledDate = {(current) => current &&  current < moment().endOf('day') || (current < moment(spawnRange.startDate, 'MM/DD/YYYY').endOf('day') || (spawnRange.endDate ? current > moment(spawnRange.endDate, 'MM/DD/YYYY').subtract(1, 'day').endOf('day') : false))}
                    />
                    <ValidationMessage visible={focusedOutSpawnDate && !startDate}>Please enter spwan date</ValidationMessage>
                </Col>
            </Row>}
        </FormContainer>
    );
};

export default ScheduleOptions;